import InputAuth from '../common/inputAuth'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, SubmissionError } from 'redux-form'
import { validaPreLogin, login, validaUsuario, getIntegracaoSistema } from '../../actions/authActions'
import { getIPs, detectBrowser } from '../../util/helper'
import Messages from '../../components/common/Toastr/messages'
import { Button, Card, CardBody, CardGroup, Col, Container, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap'
import AlterarPwd from '../AlterarPwd/page';
import MfaSmartForm from '../MfaSmart/page';
import { toastr } from 'react-redux-toastr';
import { validateMessages } from '../../constants/messages'
import { gerarCodigoMfa } from '../../actions/mfaActions';

class Page extends Component {

    constructor(props) {
        super(props);
        this.state = {
            esquecipdw: false,
            Private_IP: '0.0.0.0',
            Public_IP: '0.0.0.0',
            browser: '',
            options: this.props.options || {},
            bgColor: this.props.options.bgColor || '#fff',
            textColor: this.props.options.textColor || '#000000',
            theme: this.props.options.theme || '',
            version: !!this.props.options.version ? `v:${this.props.options.version}` : '',
            copyright: this.props.options.copyright || '',
            redirect: this.props.options.redirect || '/',
            backgroundImage: this.props.options.backgroundImage || '',
            boxTitle: this.props.options.boxTitle || '',
            bgColorBoxTitle: this.props.options.bgColorBoxTitle || '',
            bgColorLogo: this.props.options.bgColorLogo || '',
            textColorBoxTitle: this.props.options.textColorBoxTitle || '#000000',
            logoImg: this.props.options.logoImg || '',
            verifyCpfCnpj: this.props.options.verifyCpfCnpj || false,
            isPassword: true,
            mfa: false,
        }
        this.esquecipdw = this.esquecipdw.bind(this);
        this.saveState = this.saveState.bind(this);
        this.page = this.page.bind(this);
        this.changePass = this.changePass.bind(this);
        this.mfaSmart = this.mfaSmart.bind(this);
        this.body = {
            IdUsuario: null,
            Email: null,
            Usuario: null
        }
    }

    componentWillMount() {
        getIPs((ip) => {
            if (ip.match(/^(192\.168\.|169\.254\.|10\.|172\.(1[6-9]|2\d|3[01]))/)) {
                this.saveState('Private_IP', ip)
            } else {
                this.saveState('Public_IP', ip)
            }
        })
        this.saveState('browser', detectBrowser())
        this.saveState('textWhite', this.props.options.theme === 'admin' ? 'text-white' : '')
        this.saveState('bgColor', this.props.options.theme === 'admin' ? 'grey' : this.state.bgColor)
    }

    componentDidMount() {
        const hasTokenExpired = sessionStorage.getItem('tokenExpired');
        if (hasTokenExpired) {
            sessionStorage.removeItem('tokenExpired');
            toastr.error('Atenção', validateMessages.tokenExpirado);
        }
    }

    esquecipdw() {
        this.setState({ esquecipdw: !this.state.esquecipdw });
    }

    mfaSmart() {
        this.setState({ mfa: !this.state.mfa })
    }


    async onSubmit(values) {
        try {

            const { login } = this.props;
            values.verifyCpfCnpj = this.state.verifyCpfCnpj;
            values.ip = {
                'Private_IP': this.state.Private_IP,
                'Public_IP': this.state.Public_IP
            }
            values.browser = this.state.browser;

            /* Validação de erros pós submit do redux-form */
            let errors = {};

            if (!values.login) {
                toastr.error('Atenção', validateMessages.loginField);
                errors.login = validateMessages.loginField;
            }

            if (!values.password) {
                toastr.error('Atenção', validateMessages.passwordField);
                errors.password = validateMessages.passwordField;
            }

            if (Object.keys(errors).length > 0) {
                throw new SubmissionError(errors)
            }

            //console.log('submitvalues', values)
            const prelogin = await validaPreLogin(values);
            //console.log('submitprelogin', prelogin)

            if (prelogin) {
                const usuarioMFA = await validaUsuario(values.login);
                if (usuarioMFA.data.success) {
                    if (!usuarioMFA.data.ativo) {
                        login(values);
                    }
                    else {
                        const config = await getIntegracaoSistema();
                        this.body.Email = usuarioMFA.data.obj.email;
                        this.body.IdUsuario = usuarioMFA.data.obj.IdUsuario;
                        this.body.Usuario = usuarioMFA.data.obj.Nome;

                        const gera = await gerarCodigoMfa(this.body, config.data.obj);
                        if (gera) {
                            this.setState({ geraData: gera, prelogin: prelogin });
                        }
                    }
                }
            }
        } catch (error) {
            toastr.error('Login Inválido !')
            //console.log('Erro ao validar Login.', error);
        }

    }

    saveState(key, value) {
        this.setState({ [key]: value })
    }

    changePass() {
        this.setState({ isPassword: !this.state.isPassword })
    }

    login() {
        const { handleSubmit, options: { bgColorContainer } } = this.props;

        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <div>
                        <Row className="justify-content-center">
                            <Col md="8">
                                {this.state.boxTitle && <Card md="8" style={{
                                    backgroundColor: this.state.bgColorBoxTitle,
                                    borderRadius: '0.25rem 0.25rem 0 0',
                                    borderStyle: 'none',
                                    margin: '0',
                                    padding: '12px 0 0 44px',
                                }}>
                                    <h1 style={{ color: this.state.textColorBoxTitle, fontSize: '25px' }}>{this.state.boxTitle}</h1>
                                </Card>}
                                <CardGroup style={{
                                    border: 'solid  0px 0px 0px  blue',
                                    boxShadow: '10px 10px 10px grey',
                                    backgroundColor: bgColorContainer || '',
                                    borderRadius: this.state.boxTitle ? '0 0 0.25rem 0.25rem' : '0.25rem',

                                }}>

                                    <Card className="p-4" style={{
                                        backgroundColor: bgColorContainer || this.state.bgColor,
                                        borderRadius: this.state.boxTitle ? '0 0 0.25rem 0.25rem' : '0.25rem',
                                        borderStyle: 'none',
                                        color: this.state.textColor
                                    }}>
                                        <CardBody style={{ color: this.state.textColor }}>
                                            <h1 style={{ color: this.state.textColor }}>Login</h1>
                                            <p style={{ color: this.state.textColor }}>Entrar no sistema</p>
                                            <form onSubmit={handleSubmit(v => this.onSubmit(v))}>
                                                <InputGroup className="mb-3">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="icon-user"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Field component={InputAuth} type="input" name="login"
                                                        placeholder="Login" icon='user' autocomplete="login" />
                                                </InputGroup>
                                                <InputGroup className="mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="icon-lock"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Field component={InputAuth} type={this.state.isPassword ? 'password' : 'input'} name="password"
                                                        placeholder="Senha" icon='lock' autocomplete="current-password" />
                                                </InputGroup>
                                                <Row>
                                                    <Col xs="5">
                                                        <Button color="primary-smart" className="px-4">
                                                            Entrar
                                                        </Button>
                                                    </Col>

                                                    <Col xs="7" className="text-right " >
                                                        {
                                                            this.state.options.esqueciSenha && this.props.options.theme !== 'admin' ?
                                                                <Button color="link secondary"
                                                                    className="px-0"
                                                                    id='esqueciSenha'
                                                                    onClick={this.esquecipdw}>Esqueci minha senha</Button>
                                                                : ''
                                                        }
                                                    </Col>
                                                </Row>
                                            </form>
                                        </CardBody>
                                    </Card>
                                    <Card className="text-white bg-primary-smart py-5 d-md-down-none"
                                        style={{
                                            border: 'solid  0px blue', width: 44 + '%',
                                            backgroundColor: this.state.bgColorLogo,
                                            backgroundImage: 'url(' + this.state.backgroundImage + ')',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center center',
                                            backgroundRepeat: 'no-repeat',
                                        }}>
                                        <CardBody className="text-center pt-6">
                                            <div>
                                                <img src={this.props.options.logoImg}
                                                    align="middle"
                                                    width="100%"
                                                    alt="NewSpace" />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardGroup>
                                <Messages />
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col md="8">

                                <div className="pull-right">{this.state.version}</div>
                                <div style={{
                                    textAlign: 'center'
                                }}>{this.state.copyright}</div>
                            </Col>
                        </Row>
                    </div>

                </Container>
            </div>
        );
    }

    AlterarSenha() {
        return (
            <div>
                <AlterarPwd
                    redirectBack='/'
                    redirectSuccess='/'
                ></AlterarPwd>
            </div >)
    }

    MfaLogin() {
        const { geraData } = this.state;
        const { prelogin } = this.state;
        return (
            <div>
                <MfaSmartForm
                    dataExpiracao={geraData ? geraData.data_expiracao : null}
                    tempoEnvio={geraData ? geraData.tempo_reenvio : null}
                    IdUsuario={this.body.IdUsuario}
                    Email={this.body.Email}
                    Usuario={this.body.Usuario}
                    redirectBack='/'
                    redirectSuccess='/'
                    prelogin={prelogin}
                ></MfaSmartForm>
            </div >)
    }

    page() {
        const { isAuthenticated, esquecipdw, alterpwd, provisionalLogin, mfa } = this.props;

        const { geraData } = this.state;

        if (geraData) {
            return this.MfaLogin();
        }

        if (isAuthenticated && !esquecipdw) {
            const user = sessionStorage["_nscorporate_user"] ? JSON.parse(sessionStorage["_nscorporate_user"]) : {}
            if ((new Date() > new Date(user.nextchangepwd)))
                return this.AlterarSenha()
            else if (alterpwd || provisionalLogin)
                return this.AlterarSenha()

            else
                return document.location.href = this.state.redirect
        }
        else
            return this.login()


    }

    render() {
        return (
            this.page()
        )
    }
}

Page = reduxForm({ form: 'Login' })(Page)
const mapStateToProps = state => ({
    isAuthenticated: state.authreducer.isAuthenticated,
    user: state.authreducer.user,
    alterpwd: state.authreducer.alterpwd,
    provisionalLogin: state.authreducer.provisionalLogin
})

const mapDispatchToProps = dispatch => (
    bindActionCreators({ login }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(Page)
